<template>
    <div class="product-container">
        <el-carousel :height="computeHeight">
            <el-carousel-item v-for="(item, index) in sliders" :key="index">
                <img :src="item.img" class="slider_img" :style="{ height: computeHeight }" />
            </el-carousel-item>
        </el-carousel>
        <div class="solve">
            <div class="f-label font_size_30">主要产品</div>
            <div class="s-label font_size_14">MAIN PRODUCT</div>
        </div>
        <div class="product">
            <el-tabs v-if="seen" v-model="activeName" @tab-click="handleClick" class="tabs">
                <el-tab-pane label="邮你采" name="1">
                    <div class="product-list">
                        <img src="../../assets/product/logo_ync_w@2x.png" class="product-img" />
                        <div class="title-content">
                            <div class="title">面向终端用户App/小程序</div>
                            <div class="content">
                                面向终端客户提供的一站式医药采购服务终端，实现了终端注册登录、资质审核、商品采购、订单支付、售后申请一条龙服务流程。
                            </div>
                            <el-button class="btn" @click="handleSelectLogin('终端入驻')"
                                >申请终端入驻</el-button
                            >
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="邮店铺" name="2">
                    <div class="product-list">
                        <img src="../../assets/product/logo_ydp_w@2x.png" class="product-img" />
                        <div class="title-content">
                            <div class="title" style="color: #ea5f3a">
                                面向生产工业App/小程序/网站
                            </div>
                            <div class="content">
                                定位为商家运营服务平台，旨在为工业店铺运营提供便捷的通道，随时随地掌控店铺经营状况，提升店铺运营效率与企业盈利能力。
                            </div>
                            <el-button
                                class="btn"
                                style="background: #ea5f3a"
                                @click="handleSelectLogin('工业入驻')"
                                >申请工业入驻</el-button
                            >
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="邮业务" name="3">
                    <div class="product-list">
                        <img src="../../assets/product/logo_yyw_w@2x.png" class="product-img" />
                        <div class="title-content">
                            <div class="title" style="color: #0074c6">面向业务员App/小程序</div>
                            <div class="content">
                                专门为业务推广团队打造的一款营销服务工具，实现了业务员入驻申请、绑定终端、业务推广、合作签约、分佣提现完整业务流程。
                            </div>
                            <el-button
                                class="btn"
                                style="background: #0074c6"
                                @click="handleSelectLogin('业务员入驻')"
                                >申请成为业务员</el-button
                            >
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <div v-else class="product-box">
                <div class="product-list">
                    <img src="../../assets/product/logo_ync_w@2x.png" class="product-img" />
                    <div class="title-content">
                        <div class="title">面向终端用户App/小程序</div>
                        <div class="content">
                            面向终端客户提供的一站式医药采购服务终端，实现了终端注册登录、资质审核、商品采购、订单支付、售后申请一条龙服务流程。
                        </div>
                        <el-button class="btn" @click="handleSelectLoginMobile('终端入驻')"
                            >申请终端入驻</el-button
                        >
                    </div>
                </div>
                <div class="product-list">
                    <img src="../../assets/product/logo_ydp_w@2x.png" class="product-img" />
                    <div class="title-content">
                        <div class="title" style="color: #ea5f3a">面向生产工业App/小程序/网站</div>
                        <div class="content">
                            定位为商家运营服务平台，旨在为工业店铺运营提供便捷的通道，随时随地掌控店铺经营状况，提升店铺运营效率与企业盈利能力。
                        </div>
                        <el-button
                            class="btn"
                            style="background: #ea5f3a"
                            @click="handleSelectLoginMobile('工业入驻')"
                            >申请工业入驻</el-button
                        >
                    </div>
                </div>
                <div class="product-list">
                    <img src="../../assets/product/logo_yyw_w@2x.png" class="product-img" />
                    <div class="title-content">
                        <div class="title" style="color: #0074c6">面向业务员App/小程序</div>
                        <div class="content">
                            专门为业务推广团队打造的一款营销服务工具，实现了业务员入驻申请、绑定终端、业务推广、合作签约、分佣提现完整业务流程。
                        </div>
                        <el-button
                            class="btn"
                            style="background: #0074c6"
                            @click="handleSelectLoginMobile('业务员入驻')"
                            >申请成为业务员</el-button
                        >
                    </div>
                </div>
            </div>
            <div class="title-bar">
                <div class="bar" />
                <div>
                    <span class="f-title">产品特点</span>
                    <span class="s-title">PRODUCT FEATURES</span>
                </div>
            </div>
            <div class="feature">
                <div v-for="(item, index) in featuresList" :key="index" class="feature-item">
                    <img :src="item.img" class="feature-item-img" />
                    <div class="feature-item-right">
                        <div class="title">{{ item.title }}</div>
                        <div class="content">{{ item.content }}</div>
                    </div>
                </div>
            </div>
            <div class="title-bar">
                <div class="bar" />
                <div>
                    <span class="f-title">销控体系</span>
                    <span class="s-title">SALES CONTROL SYSTEM</span>
                </div>
            </div>
            <img src="../../assets/product/15@2x.png" class="img-1" />
            <div class="title-bar">
                <div class="bar" />
                <div>
                    <span class="f-title">配送服务体系</span>
                    <span class="s-title">DISTRIBUTION SETVICE SYSTEM</span>
                </div>
            </div>
            <img src="../../assets/product/29@2x.png" class="img-2" />
        </div>
        <div class="solve">
            <div class="f-label font_size_30">目标市场与服务客群</div>
            <div class="s-label font_size_14">Target market and service customer base</div>
        </div>
        <div class="finance">
            <!-- <div class="finance-product">
                <img src="../../assets/product/logo_yfb_w@2x.png" class="product-img">
                <div class="title-content">
                    <div class="title">面向终端用户App/小程序</div>
                    <div class="content">终端通过邮你采平台采购药品，以邮福宝作为授信支付结算工具，并将授信纳入征信体系。银行根据终端征信情况及采购明细，先行向工业垫付货款，既保证终端正常经营，又帮助工业快速回笼资金，同时降低了工业药品生产成本以及终端的运营成本，最终让百姓获益。</div>
                </div>
            </div> -->
            <img src="../../assets/product/19@2x.png" class="img-3" />
        </div>

        <!-- 扫码入驻 -->
        <el-dialog
            :title="'申请' + activeTitle"
            :visible.sync="showLoginDialog"
            width="380px"
            center
            :show-close="false"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
        >
            <div class="login-dialog">
                <div v-if="activeTitle === '工业入驻'" class="tips-1">
                    申请工业入驻，请扫码关注邮你采微信公众号后，在公众号上申请！
                </div>
                <div v-if="activeTitle === '终端入驻'" class="tips-1">
                    请扫下方二维码下载邮你采App，注册成为我们的终端用户，期待您的加入！
                </div>
                <div v-if="activeTitle === '业务员入驻'" class="tips-1">
                    请扫下方二维码下载邮业务App，注册成为我们的业务员，期待您的加入！
                </div>
                <div v-if="activeTitle === '终端入驻'" class="tips-2">
                    申请资格：必须是合规的售药单位才可申请入驻。
                </div>
                <div v-if="activeTitle === '工业入驻'" class="tips-2">
                    或拨打客服电话：15306997110
                </div>
                <img
                    v-if="activeTitle === '工业入驻'"
                    class="code-img"
                    src="../../assets/main/yncgzh.png"
                />
                <img
                    v-if="activeTitle === '终端入驻'"
                    class="code-img"
                    src="../../assets/qrcode/ync.png"
                />
                <img
                    v-if="activeTitle === '业务员入驻'"
                    class="code-img"
                    src="../../assets/qrcode/yyw.png"
                />
                <div class="code-title"></div>
                <div class="close-btn" @click="showLoginDialog = false">关 闭</div>
            </div>
        </el-dialog>

        <!-- 移动端对话框 -->
        <van-dialog v-model="show" :title="'申请' + activeTitle" :showConfirmButton="false">
            <div class="login-dialog">
                <div v-if="activeTitle === '工业入驻'" class="tips-1">
                    申请工业入驻，请扫码关注邮你采微信公众号后，在公众号上申请！
                </div>
                <div v-if="activeTitle === '终端入驻'" class="tips-1">
                    请扫下方二维码下载邮你采App，注册成为我们的终端用户，期待您的加入！
                </div>
                <div v-if="activeTitle === '业务员入驻'" class="tips-1">
                    请扫下方二维码下载邮业务App，注册成为我们的业务员，期待您的加入！
                </div>
                <div v-if="activeTitle === '终端入驻'" class="tips-2">
                    申请资格：必须是合规的售药单位才可申请入驻。
                </div>
                <div v-if="activeTitle === '工业入驻'" class="tips-2">
                    或拨打客服电话：15306997110
                </div>
                <img
                    v-if="activeTitle === '工业入驻'"
                    class="code-img"
                    src="../../assets/main/yncgzh.png"
                />
                <img
                    v-if="activeTitle === '终端入驻'"
                    class="code-img"
                    src="../../assets/qrcode/ync.png"
                />
                <img
                    v-if="activeTitle === '业务员入驻'"
                    class="code-img"
                    src="../../assets/qrcode/yyw.png"
                />
                <div class="code-title">单击识别二维码</div>
                <div class="close-btn" @click="show = false">关 闭</div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
export default {
    name: 'ProductPage',
    data() {
        return {
            featuresList: [
                {
                    img: require('../../assets/product/f1@2x.png'),
                    title: '工业企业直销',
                    content: '邮你采平台销售商品均为工业企业直销药品，原厂原标，品质保证。'
                },
                {
                    img: require('../../assets/product/f2@2x.png'),
                    title: '交易快速便捷',
                    content:
                        '邮你采平台销售品类覆盖药品、食品、器械等，一站式医药采购服务体验，交易快速便捷。'
                },
                {
                    img: require('../../assets/product/f3@2x.png'),
                    title: '全国统一价格',
                    content:
                        '工业一店发全国，药品定价权回归工业，稳固商品价格体系，有效避免中间商囤货居奇哄抬药品价格与行业恶意竞价。'
                },
                {
                    img: require('../../assets/product/f4@2x.png'),
                    title: '药品流通溯源',
                    content:
                        '终端与工业面对面交易，保证终端获得一手货源，同时工业可查看药品流通数据，使得药品流通更加透明，监管溯源更全面。'
                }
            ],
            activeName: '1',
            activeTitle: '',
            showLoginDialog: false,
            show: false,
            screenWidth: document.body.clientWidth
        }
    },
    computed: {
        //计算高度
        computeHeight() {
            const m = 700 / 1920
            const mm = 210 / 375
            if (this.screenWidth > 768) {
                return (this.screenWidth * m).toFixed(2) + 'px'
            } else {
                return (this.screenWidth * mm).toFixed(2) + 'px'
            }
        },
        seen() {
            // 屏幕尺寸
            let screenWidth = document.body.clientWidth
            if (screenWidth > 768) {
                return true
            } else {
                return false
            }
        },
        sliders() {
            let screenWidth = document.body.clientWidth
            let arr = []
            if (screenWidth > 768) {
                arr = [{ img: require('../../assets/banner/banner5.png') }]
                return arr
            } else {
                arr = [{ img: require('../../assets/banner/banner5@2x.png') }]
                return arr
            }
        }
    },
    mounted() {
        const _this = this
        window.onresize = () => {
            return (() => {
                _this.screenWidth = document.body.clientWidth
            })()
        }
    },
    methods: {
        handleClick() {},
        handleSelectLogin(key) {
            this.showLoginDialog = true
            this.activeTitle = key
        },

        handleSelectLoginMobile(key) {
            this.show = true
            this.activeTitle = key
        }
    }
}
</script>

<style scoped lang="scss">
.product-container {
    .slider_img {
        height: 700px;
        width: 100%;
    }

    .font_size_30 {
        font-size: 1.875em;
    }

    .font_size_14 {
        font-size: 0.875rem;
    }

    .solve {
        padding-top: 50px;
        padding-bottom: 15px;
        position: relative;

        .f-label {
            text-align: center;
            color: #157e3b;
        }

        .s-label {
            text-align: center;
            color: #aaaaaa;
            margin-top: 10px;
        }

        .more-img {
            position: absolute;
            right: 19%;
            top: 65px;
            width: 77px;
            height: 32px;
            background-image: url('../../assets/main/pic_more_nor@2x.png');
            background-size: 100% 100%;
        }
    }

    .product {
        display: flex;
        flex-direction: column;
        align-items: center;
        .title-bar {
            display: flex;
            align-items: center;
            margin-bottom: 36px;
            width: 1200px;
            .bar {
                width: 6px;
                height: 30px;
                background: #2f9458;
                margin-right: 12px;
            }

            .f-title {
                font-size: 1.5rem;
                font-weight: bold;
                color: #157e3b;
                line-height: 32px;
                margin-right: 8px;
            }

            .s-title {
                height: 30px;
                font-size: 0.875rem;
                color: #aaaaaa;
                text-align: end;
            }
        }

        .el-tabs {
            width: 1200px;
        }
        ::v-deep .el-tabs__item {
            width: 400px;
            font-size: 1.25rem;
            font-weight: bold;
            line-height: 28px;
            text-align: center;
            &.is-active {
                color: #137e3b;
            }
            &:hover {
                color: #137e3b;
            }
        }
        ::v-deep .el-tabs__active-bar {
            background-color: #137e3b;
            width: 400px;
            height: 4px;
        }
        .product-list {
            width: 1000px;
            background: #ffffff;
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.26);
            border-radius: 8px;
            padding: 17px 40px;
            display: flex;
            align-items: center;
            margin-bottom: 18px;
            margin: 20px auto;
            margin-bottom: 30px;
            .product-img {
                width: 100px;
                height: 100px;
                margin-right: 35px;
            }
            .title-content {
                .title {
                    font-size: 1.25rem;
                    font-weight: bold;
                    color: #137e3b;
                    line-height: 28px;
                    margin-bottom: 10px;
                }

                .content {
                    width: 650px;
                    font-size: 0.875rem;
                    color: #666666;
                    line-height: 24px;
                }

                .btn {
                    // width: 124px;
                    height: 36px;
                    background: #2f9458;
                    box-shadow: 0px 3px 10px 0px rgba(22, 138, 26, 0.22);
                    border-radius: 4px;
                    color: #ffffff;
                    padding: 10px 20px;
                    margin-top: 13px;
                    font-size: 0.875rem;
                }
            }
        }

        .feature {
            width: 1000px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-bottom: 40px;

            &-item {
                width: 490px;
                display: flex;
                background: #ffffff;
                box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.26);
                border-radius: 8px;
                margin-bottom: 20px;

                &-img {
                    width: 164px;
                    // height: 130px;
                    height: 100%;
                }

                &-right {
                    padding: 17px 21px;
                    .title {
                        font-size: 1.125rem;
                        font-weight: bold;
                        color: #000000;
                        line-height: 25px;
                    }
                    .content {
                        margin-top: 10px;
                        font-size: 0.875rem;
                        color: #000000;
                        line-height: 20px;
                    }
                }
            }
        }

        .img-1 {
            width: 1125px;
            height: 427px;
            margin-bottom: 57px;
        }
        .img-2 {
            width: 1200px;
            height: 485px;
            margin-bottom: 20px;
        }
    }

    .finance {
        margin-top: 15px;
        margin-bottom: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;

        &-product {
            width: 1000px;
            background: #ffffff;
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.26);
            border-radius: 11px;
            padding: 30px 40px;
            display: flex;
            margin-bottom: 18px;
            .product-img {
                width: 100px;
                height: 100px;
                margin-right: 35px;
            }
            .title-content {
                .title {
                    font-size: 1.25rem;
                    font-weight: bold;
                    color: #000000;
                    line-height: 28px;
                    margin-bottom: 10px;
                }

                .content {
                    font-size: 0.875rem;
                    color: #666666;
                    line-height: 24px;
                }
            }
        }

        .img-3 {
            width: 1201px;
            height: 634px;
        }
    }

    .login-dialog {
        background: #ffffff;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 0.75rem;
        color: #333333;
        line-height: 17px;

        .title {
            font-size: 1rem;
            line-height: 22px;
            font-weight: bold;
            margin-bottom: 18px;
        }

        .tips-1 {
            width: 268px;
            line-height: 17px;
            margin-bottom: 6px;
        }
        .tips-2 {
            width: 268px;
            line-height: 17px;
            color: #15803c;
        }
        .code-img {
            width: 126px;
            height: 126px;
            margin-top: 18px;
        }
        .code-title {
            margin-top: 12px;
            margin-bottom: 16px;
        }

        .close-btn {
            width: 208px;
            height: 36px;
            background: #2f9458;
            box-shadow: 0px 3px 10px 0px rgba(22, 138, 26, 0.22);
            border-radius: 4px;
            font-size: 0.875rem;
            color: #ffffff;
            text-align: center;
            line-height: 36px;

            &:hover {
                cursor: pointer;
            }
        }
    }

    ::v-deep .el-dialog__body {
        padding: 0 16px 16px 16px;
    }
    // ::v-deep .el-icon-close:before {
    //     content: '';
    // }
    ::v-deep .el-dialog {
        border-radius: 5px;
    }

    @media screen and (max-device-width: 768px) {
        .slider_img {
            // height: 210px;
            height: 137px;
            width: 100%;
        }
        .font_size_30 {
            font-size: 0.9375rem; // 15px
        }

        .font_size_14 {
            font-size: 0.625rem; // 10px
        }

        .solve {
            width: 100%;
            padding-top: 14px;
            padding-bottom: 14px;
            position: relative;
            .f-label {
                text-align: center;
                color: #157e3b;
            }

            .s-label {
                text-align: center;
                color: #aaaaaa;
                margin-top: 6px;
            }

            .more-img {
                position: absolute;
                right: 16px;
                top: 20px;
                width: 48px;
                height: 20px;
                background-image: url('../../assets/main/pic_more_nor@2x.png');
                background-size: 100% 100%;
            }
        }

        .product {
            .product-box {
                width: calc(100% - 32px);
                padding: 0 16px;
                margin-bottom: 16px;
                .product-list {
                    width: auto;
                    padding: 17px 10px;
                    margin: 0;
                    margin-bottom: 16px;
                    .product-img {
                        margin-right: 6px;
                    }
                    .title-content {
                        .title {
                            font-size: 0.875rem;
                            line-height: 20px;
                        }
                        .content {
                            font-size: 0.75rem;
                            line-height: 18px;
                            width: auto;
                        }
                    }
                }
            }

            .title-bar {
                width: 100%;
                margin-bottom: 10px;
                .bar {
                    width: 4px;
                    height: 16px;
                    margin-left: 16px;
                    margin-right: 5px;
                }
                .f-title {
                    font-size: 0.875rem;
                    line-height: 20px;
                    margin-right: 5px;
                }
                .s-title {
                    font-size: 0.5rem;
                    line-height: 20px;
                }
            }

            .feature {
                width: calc(100% - 32px);
                padding: 0 16px;
                margin-bottom: 13px;
                margin-top: 8px;
                .feature-item {
                    width: 100%;
                    margin-bottom: 16px;
                    height: 114px;
                    .feature-item-img {
                        width: 144px;
                        height: 114px;
                    }
                    .feature-item-right {
                        padding: 10px;
                        .title {
                            font-size: 0.875rem;
                            line-height: 20px;
                        }
                        .content {
                            font-size: 0.75rem;
                            line-height: 17px;
                            margin-top: 4px;
                        }
                    }
                }
            }

            .img-1 {
                width: 343px;
                height: 130px;
                margin-bottom: 13px;
            }
            .img-2 {
                width: 343px;
                height: 141px;
                margin-bottom: 16px;
            }
        }

        .finance {
            width: calc(100% - 32px);
            padding: 0 16px;
            margin-top: 4px;
            margin-bottom: 18px;
            .finance-product {
                width: auto;
                padding: 12px 10px;
                .product-img {
                    margin: auto 0;
                    margin-right: 6px;
                }
                .title-content {
                    .title {
                        font-size: 0.875rem;
                        line-height: 20px;
                    }
                    .content {
                        font-size: 0.75rem;
                        line-height: 18px;
                    }
                }
            }
            .img-3 {
                width: 344px;
                height: 112px;
            }
        }

        .login-dialog {
            .tips-1 {
                margin-top: 15px;
            }
            .close-btn {
                margin-bottom: 17px;
            }
        }
    }

    @media screen and (min-device-width: 769px) and (max-device-width: 1100px) {
        .product {
            .el-tabs {
                width: 750px;
            }
            ::v-deep .el-tabs__item {
                width: 250px;
            }
            ::v-deep .el-tabs__active-bar {
                width: 250px;
            }

            .title-bar {
                width: calc(100% - 40px);
            }

            .product-list {
                width: calc(100% - 100px);
                .title-content {
                    .content {
                        width: calc(100%);
                    }
                }
            }
            .feature {
                width: calc(100% - 80px);
                .feature-item {
                    width: calc(50% - 20px);
                }
            }
            .img-1 {
                width: 750px;
                height: 284px;
            }

            .img-2 {
                width: 750px;
                height: 303px;
            }
        }

        .finance {
            .finance-product {
                width: calc(100% - 120px);
            }
            .img-3 {
                width: 750px;
                height: 222px;
            }
        }
    }
}
</style>
